import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useOnboarding } from '../../context/OnboardingContext'
import StepDrawer from './StepDrawer'
import ConnectMailboxStep from './steps/ConnectMailboxStep'
import DNSCheckStep from './steps/DNSCheckStep'
import WarmupStep from './steps/WarmupStep'
import FirstCampaignStep from './steps/FirstCampaignStep'
import './OnboardingRail.css'

const STEPS = [
  { key: 'mailbox',  label: 'Connect mailbox',   Component: ConnectMailboxStep, num: 1 },
  { key: 'dns',      label: 'Verify DNS',        Component: DNSCheckStep,       num: 2 },
  { key: 'warmup',   label: 'Start warmup',      Component: WarmupStep,         num: 3 },
  { key: 'contacts', label: 'Import contacts',   Component: null,               num: 4, route: '/contacts' },
  { key: 'campaign', label: 'First campaign',    Component: FirstCampaignStep,  num: 5 },
]

export default function OnboardingRail() {
  const { state, progress, total, visible, patch, refresh } = useOnboarding()
  const [openStep, setOpenStep] = useState(null)
  const navigate = useNavigate()

  // Reserve right-side gutter only while the rail is actually shown,
  // so finished/collapsed onboarding doesn't leave a blank column.
  const railActive = visible && !state.rail_collapsed
  useEffect(() => {
    document.body.classList.toggle('onb-rail-active', railActive)
    return () => document.body.classList.remove('onb-rail-active')
  }, [railActive])

  if (!visible || state.rail_collapsed) return null

  const openHandler = (s) => {
    if (s.route) { navigate(s.route); return }
    setOpenStep(s)
  }

  const closeDrawer = () => { setOpenStep(null); refresh() }

  return (
    <>
      <aside className="onb-rail">
        <div className="onb-rail-head">
          <div className="onb-rail-title">
            Get started <span className="onb-rail-count">{progress}/{total}</span>
          </div>
          <button className="onb-rail-collapse" onClick={() => patch({ rail_collapsed: true })} aria-label="Collapse">
            ×
          </button>
        </div>
        <div className="onb-rail-progress">
          <div className="onb-rail-progress-bar" style={{ width: `${(progress / total) * 100}%` }} />
        </div>
        <ul className="onb-rail-steps">
          {STEPS.map((s) => {
            const done = state.steps[s.key]
            const skipped = (state.skipped_steps || []).includes(s.num)
            return (
              <li key={s.key}
                  className={`onb-step ${done ? 'done' : skipped ? 'skipped' : 'pending'}`}
                  onClick={() => openHandler(s)}>
                <span className="onb-step-icon">{done ? '✓' : skipped ? '–' : '○'}</span>
                <span className="onb-step-label">{s.label}</span>
              </li>
            )
          })}
        </ul>
      </aside>
      {openStep && (
        <StepDrawer title={openStep.label} onClose={closeDrawer}>
          <openStep.Component onDone={closeDrawer} />
        </StepDrawer>
      )}
    </>
  )
}
